import { Button, Modal } from "@mantine/core";
import { ModalFooter } from "../../../mantine/components/ModalFooter/ModalFooter";

interface AuthDeactivationConfirmModalProps {
  isOpen: boolean;
  onToggle: () => void;
  onAuthDeactivationConfirm: () => void;
}

function AuthDeactivationConfirmModal({
  isOpen,
  onToggle,
  onAuthDeactivationConfirm
}: AuthDeactivationConfirmModalProps) {
  return (
    <Modal
      opened={isOpen}
      title="Bestätigen Sie Ihre Aktion"
      onClose={onToggle}
    >
      <p>
        Die 2-Faktor-Authentifizierung (2FA) erhöht die Sicherheit Ihres
        Nutzerkontos, indem sie eine zusätzliche Sicherheitsebene darstellt. Wir
        raten Ihnen daher davon ab die 2FA zu deaktivieren und den erweiterten
        Schutz beizubehalten.
      </p>
      <ModalFooter>
        <Button variant="default" onClick={onToggle}>
          Schließen
        </Button>
        <Button color="secondary" onClick={onAuthDeactivationConfirm}>
          Weiter
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export { AuthDeactivationConfirmModal };
